module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/email/banner-e04a813bd233663bd1cae71919dec8c5.jpg";